import { createActions } from 'reflux';

const AppActions = createActions({
  setSelected: {},
});

export default AppActions;



/** WEBPACK FOOTER **
 ** ./app/scripts/actions/app.es6
 **/